export default {
    general: {
        add:            'Dodaj',
        edit:           'Uredi',
        delete:         'Izbriši',
        cancel:         'Prekliči',
        close:          'Zapri',
        confirm:        'Potrdi',
        save:           'Shrani',
        sign_out:       'Odjava',
        loading:        'Nalagam …',
        refresh:        'Osveži',
        search:         'Iskanje',
        from:           'Od',
        to:             'Do',
        today:          'Danes',
        previous_day:   'Prejšnji dan',
        previous:       'Nazaj',
        next:           'Naprej',
        next_day:       'Naslednji dan',
        all:            'Vse',
        all_facilities: 'Vsa področja',
        name:           'Naziv',
        description:    'Opis',
        email:          'E-pošta',
        status:         'Stanje',
        active:         'Aktivno',
        inactive:       'Neaktivno',
        copy:           'Kopiraj',
        copied:         'Kopirano',
    },
    brand: {
        product_name: 'Rezervacije',
        tagline:      'Termini in viri',
    },
    nav: {
        customers:   'Stranke',
        board:       'Tabla',
        bookings:    'Rezervacije',
        closures:    'Zaprtja',
        settings:    'Nastavitve',
        tenants:     'Stranke',
        pms_installations: 'Namestitve PMS',
        group_admin: 'Upravljanje',
        reports:     'Pregledi',
        schedule:    'Urnik',
        my_schedule: 'Moj urnik',
    },
    layout: {
        open_menu:  'Odpri meni',
        close_menu: 'Zapri meni',
    },
    color_mode: {
        switch_to_light: 'Preklopi na svetlo',
        switch_to_dark:  'Preklopi na temno',
    },
    errors: {
        generic_error:      'Prišlo je do napake',
        invalid_data:       'Neveljavni podatki',
        not_found:          'Ne obstaja',
        unauthorized:       'Niste prijavljeni',
        forbidden:          'Za to nimate pravic',
        slot_unavailable:   'Termin ni več prost',
        incorrect_status:   'Rezervacija je v stanju, ki tega ne dovoljuje',
        already_exists:     'Že obstaja',
        cancel_not_allowed: 'Odpoved ni več mogoča',
        resource_in_use:    'Vir ima prihodnje rezervacije — mreže ni mogoče spremeniti',
        pos_not_configured: 'Imprion POS ni nastavljen',
        pos_failed:         'Imprion POS je zavrnil zahtevo: {message}',
        pms_not_configured: 'Prenos na folio pri tem hotelu ni vklopljen ali nima ključa. Uredi ga skrbnik v Nastavitve → Hoteli in PMS.',
        pms_failed:         'PMS je zavrnil zahtevo: {message}',
        bill_not_possible:  'Za to rezervacijo računa ni mogoče izdati (storitev nima artikla POS ali je znesek 0)',
        billing_in_progress: 'Račun za to rezervacijo se že izdaja — počakajte trenutek in osvežite.',
        too_many_images:    'Največ 8 slik.',
        image_too_large:    'Slika je večja od 5 MB.',
        on_add:             'Napaka pri dodajanju',
        on_edit:            'Napaka pri shranjevanju',
    },
    success: {
        add:  'Uspešno dodano',
        edit: 'Uspešno shranjeno',
    },
    validation: {
        required:  'Polje je obvezno',
        email:     'Neveljaven e-poštni naslov',
        min_chars: 'Vsaj {n} znakov',
    },
    login: {
        subtitle: 'Prijava v zaledje',
        username: 'Uporabniško ime',
        password: 'Geslo',
        submit:   'Prijava',
        failed:   'Napačno uporabniško ime ali geslo',
    },
    board: {
        pick_facility: 'Izberite področje',
        no_facilities: 'Ni še nobenega področja. Dodajte ga v Nastavitvah.',
        no_resources:  'Področje nima virov. Dodajte jih v Nastavitvah.',
        closed_day:    'Ta dan ni odprt noben vir.',
        closed_week:   'Ta teden ni odprt noben vir.',
        bookings_count: '{n} rez.',
        more:          '+{n} več',
        view: {
            day:   'Dan',
            week:  'Teden',
            month: 'Mesec',
        },
        capacity:      'do {n} hkrati',
        legend: {
            free:    'Prosto',
            full:    'Zasedeno',
            blocked: 'Zaprto',
            closed:  'Izven urnika',
            booking: 'Rezervacija',
        },
    },
    availability: {
        pick_service_first: 'Najprej izberite storitev.',
        none:               'Ta dan ni prostih terminov.',
    },
    booking: {
        booking:            'Rezervacija',
        new:                'Nova rezervacija',
        create:             'Rezerviraj',
        none:               'Ni rezervacij.',
        code:               'Koda',
        time:               'Termin',
        facility:           'Področje',
        service:            'Storitev',
        resource:           'Vir',
        customer:           'Stranka',
        customer_name:      'Ime in priimek',
        customer_email:     'E-pošta',
        customer_phone:     'Telefon',
        amount:             'Znesek',
        notes:              'Opombe',
        created:            'Ustvarjeno',
        status_label:       'Stanje',
        source_label:       'Vir rezervacije',
        search_placeholder: 'Ime, e-pošta, telefon, koda',
        pick_time:          'Izberite termin',
        pick_other_time:    'Drug termin',
        move_title:         'Prestavi na drug termin',
        move_same_resource: 'Isti vir',
        confirm_cancel:     'Rezervacijo res odpovem? Termin se sprosti.',
        status: {
            booked:    'Rezervirano',
            completed: 'Opravljeno',
            cancelled: 'Odpovedano',
            no_show:   'Ni prišel',
        },
        source: {
            staff:  'Osebje',
            online: 'Splet',
        },
        action: {
            complete:     'Opravljeno',
            no_show:      'Ni prišel',
            cancel:       'Odpovej',
            reopen:       'Ponovno odpri',
            move:         'Prestavi',
            move_confirm: 'Prestavi sem',
        },
    },
    closure: {
        subtitle:           'Dopusti, prazniki, okvare — v zaprtem času ni novih rezervacij.',
        add:                'Dodaj zaprtje',
        none:               'Ni zaprtij v tem obdobju.',
        facility:           'Področje',
        resource:           'Vir',
        all_resources:      'Vsi viri področja',
        reason:             'Razlog',
        reason_placeholder: 'npr. Dopust',
        hint:               'Obstoječe rezervacije ostanejo; preverite jih na tabli.',
        to_after_from:      'Konec mora biti za začetkom',
        confirm_delete:     'Zaprtje res odstranim? Termini se znova odprejo.',
        deleted:            'Zaprtje odstranjeno',
    },
    settings: {
        tab: {
            facilities: 'Področja',
            resources:  'Viri',
            services:   'Storitve',
            users:      'Uporabniki',
            general:    'Splošno',
            pos:        'Imprion POS',
            pms:        'Hoteli in PMS',
            gates:      'Vrata',
            employees:  'Zaposleni',
        },
        general_subtitle:   'Podatki podjetja in javna stran za rezervacije.',
        description_help:   'Prikaže se na javni strani.',
        contact_email:      'Kontaktna e-pošta',
        contact_phone:      'Kontaktni telefon',
        address:            'Naslov',
        notify_email:       'E-pošta za obvestila',
        notify_email_help:  'Sem pride obvestilo o vsaki spletni rezervaciji.',
        public_page:        'Javna stran',
        public_enabled:     'Javna stran je vključena',
        public_url:         'Naslov:',
        min_notice_minutes: 'Najmanj minut vnaprej',
        min_notice_help:    'Kako zgodaj mora gost rezervirati pred začetkom.',
        max_days_ahead:     'Največ dni vnaprej',
        max_days_help:      'Kako daleč naprej gost vidi termine (1–180).',
        access_heading:     'Dostop (QR koda)',
        access_before:      'Minut pred začetkom',
        access_before_help: 'Koliko prej vstopna koda že odpre vrata (0–240).',
        access_after:       'Minut po koncu',
        access_after_help:  'Koliko po koncu termina koda še odpre vrata (0–240).',
    },
    facility: {
        subtitle:         'Področje združuje storitve in vire, npr. Wellness ali Športni center.',
        add:              'Dodaj področje',
        edit:             'Uredi področje',
        none:             'Ni še nobenega področja.',
        sort:             'Vrstni red',
        name_placeholder: 'npr. Wellness',
        description_help: 'Prikaže se na javni strani nad storitvami.',
        counts:           '{resources} virov · {services} storitev',
    },
    resource: {
        subtitle:         'Vir je to, kar storitev zasede: oseba, oprema ali prostor. Urnik vira določa proste termine.',
        add:              'Dodaj vir',
        edit:             'Uredi vir',
        none:             'Ni še nobenega vira.',
        need_facility:    'Najprej dodajte področje.',
        facility:         'Področje',
        name_placeholder: 'npr. Maserka Ana, Igrišče 1',
        kind_label:       'Vrsta',
        grid:             'Mreža',
        grid_help:        'Dolžina ene celice; na tej mreži se začenjajo termini.',
        capacity:         'Kapaciteta',
        capacity_help:    'Koliko rezervacij hkrati lahko vir sprejme.',
        hours:            'Urnik',
        hours_help:       'Tedenski delovni čas; največ dve okni na dan.',
        kind: {
            person:    'Oseba',
            equipment: 'Oprema',
            space:     'Prostor',
        },
        follows_employee: 'Urnik določa zaposleni {name} — tedenski urnik vira se ne uporablja.',
    },
    service: {
        pos_product:        'Artikel v POS',
        pos_product_help:   'Na ta artikel se izda račun; artikel določa tudi DDV.',
        pos_product_none:   'Brez artikla — računa ni mogoče izdati',
        pos_product_clear:  'Odstrani artikel',
        tax_rate:           'DDV (za postavko na foliu)',
        tax_rate_help:      'Stopnja, s katero gre storitev na hotelski folio.',
        pos_vat:            'DDV {rate} %',
        pos_badge:          'POS',
        pos_linked:         'Povezano z artiklom v Imprion POS',
        subtitle:           'Storitev je to, kar gost rezervira. Traja določeno število celic vira.',
        add:                'Dodaj storitev',
        edit:               'Uredi storitev',
        none:               'Ni še nobene storitve.',
        facility:           'Področje',
        name_placeholder:   'npr. Masaža 60 min',
        duration:           'Trajanje',
        price:              'Cena',
        pool:               'Viri',
        pool_all:           'Vsi viri področja',
        pool_help:          'Na katerih virih se storitev lahko izvaja. Prazno pomeni vse vire področja.',
        cells:              'Število celic',
        cells_help:         'Trajanje: {minutes}',
        cells_help_empty:   'Področje še nima virov.',
        extra:              'Dodatni viri',
        extra_add:          'Dodaj',
        extra_help:         'Viri, ki jih storitev zasede hkrati z glavnim, npr. druga maserka pri masaži za par.',
        extra_pick:         'Izberite vire za to vlogo',
        extra_empty:        'Izberite vsaj en vir',
        extra_count:        '{n} dodatni',
        guest_cancel_hours: 'Gost lahko odpove (ure pred začetkom)',
        guest_cancel_help:  '0 = do začetka, -1 = gost ne more odpovedati.',
        fees:               'Pozna odpoved in neprihod',
        fees_help:          'Koliko stane pozna odpoved ali neprihod, v odstotkih cene. Vsaka rezervacija si zapomni pravila, ki so veljala, ko je bila narejena. Znesek se zapiše k rezervaciji; zaračuna se ob mesečnem obračunu s hotelom.',
        late_cancel_hours:  'Pozna odpoved (ur pred začetkom)',
        late_cancel_fee:    'Pozna odpoved (%)',
        no_show_fee:        'Neprihod (%)',
        public:             'Na javni strani',
        public_short:       'Javno',
    },
    pos: {
        title:                'Imprion POS',
        subtitle:             'Ob zaključku rezervacije blagajna izda davčno potrjen račun.',
        not_configured_title: 'Povezava z Imprion POS ni na voljo',
        not_configured:       'Platforma nima nastavljenega naslova Imprion POS. Obrnite se na ponudnika.',
        enabled:              'Izdajaj račune prek Imprion POS',
        enabled_help:         'Osebje ob zaključku izbere način plačila in blagajna izda račun.',
        token:                'API ključ',
        token_help:           'Ključ vašega Imprion POS (External API).',
        token_saved:          'Ključ je shranjen — pustite prazno za nespremenjeno',
        save_token_first:     'Najprej shranite ključ, nato izberite poslovno enoto in blagajno.',
        business_unit:        'Poslovna enota',
        cash_register:        'Blagajna',
        pick:                 'Izberite',
        test:                 'Preveri povezavo',
        test_ok:              'Povezava z Imprion POS deluje',
    },
    bill: {
        title:              'Račun',
        number:             'Številka',
        amount:             'Znesek',
        issued_at:          'Izdan',
        eor_pending:        'EOR še ni prejet',
        issue:              'Izdaj račun',
        issue_title:        'Izdaja računa',
        complete_title:     'Zaključek in račun',
        payment_type:       'Način plačila',
        pick_payment_type:  'Izberite način plačila',
        complete_with:      'Zaključi in izdaj račun',
        complete_without:   'Zaključi brez računa',
    },
    hours: {
        open:          'Odprto',
        closed:        'Zaprto',
        from:          'Od',
        to:            'Do',
        add_window:    'Drugo okno',
        remove_window: 'Odstrani okno',
        copy_monday:   'Kopiraj ponedeljek na vse dni',
        invalid:       'Urnik ni veljaven: konec mora biti za začetkom, okni se ne smeta prekrivati.',
        works:         'Dela',
        day_off:       'Prost dan',
        split_shift:   'Deljen delovni čas',
        add_break:     'Malica',
        break:         'Malica',
        break_short:   'malica',
        remove_break:  'Odstrani malico',
        break_invalid: 'Malica mora biti znotraj delovnega časa in se končati za začetkom.',
        day: {
            mon: 'Ponedeljek',
            tue: 'Torek',
            wed: 'Sreda',
            thu: 'Četrtek',
            fri: 'Petek',
            sat: 'Sobota',
            sun: 'Nedelja',
        },
        short: {
            mon: 'Pon',
            tue: 'Tor',
            wed: 'Sre',
            thu: 'Čet',
            fri: 'Pet',
            sat: 'Sob',
            sun: 'Ned',
        },
    },
    user: {
        subtitle:      'Kdo se lahko prijavi v zaledje.',
        add:           'Dodaj uporabnika',
        edit:          'Uredi uporabnika',
        none:          'Ni uporabnikov.',
        role_label:    'Vloga',
        password_help: 'Vsaj 8 znakov.',
        password_keep: 'Pustite prazno, da ostane dosedanje geslo.',
        self_locked:   'Svoje vloge in aktivnosti ne morete spremeniti.',
        role: {
            platform_admin: 'Skrbnik platforme',
            admin:          'Skrbnik',
            staff:          'Osebje',
        },
    },
    tenant: {
        subtitle:    'Podjetja, ki uporabljajo Rezervacije. Vsako ima svojo bazo.',
        add:         'Dodaj stranko',
        edit:        'Uredi stranko',
        none:        'Ni še nobene stranke.',
        name:        'Naziv podjetja',
        slug:        'Oznaka',
        slug_help:   'Del naslova javne strani; male črke, številke in vezaji. Kasneje se ne da spremeniti.',
        slug_locked: 'Oznake ni mogoče spremeniti.',
        slug_invalid: '3–40 znakov: male črke, številke, vezaji',
        timezone:    'Časovni pas',
        public:      'Javna stran',
        first_admin: 'Prvi skrbnik',
    },
    image: {
        preview:        'Povečaj sliko',
        previous:       'Prejšnja slika',
        next:           'Naslednja slika',
        position:       'Slika {n} od {total}',
        cover:          'Naslovna',
        add:            'Dodaj',
        replace:        'Zamenjaj',
        delete:         'Izbriši sliko',
        confirm_delete: 'Slika bo izbrisana.',
        move_left:      'Premakni levo',
        move_right:     'Premakni desno',
        help:           'JPG, PNG ali WebP, do 5 MB, največ {n}. Prva je naslovna.',
        help_single:    'JPG, PNG ali WebP, do 5 MB.',
        wrong_type:     'dovoljene so le slike JPG, PNG in WebP',
        uploaded:       'Naloženih slik: {n}',
        photos:         'Slike',
        after_save:     'Slike dodate, ko področje ali vir shranite.',
        logo:           'Logotip',
        logo_help:      'Prikazan je v meniju in na javni strani za rezervacije.',
    },
    series: {
        repeat:            'Ponavljaj',
        frequency:         'Pogostost',
        daily:             'Dnevno',
        weekly:            'Tedensko',
        every:             'Vsakih',
        unit_days:         'dni',
        unit_weeks:        'tednov',
        end:               'Konec',
        end_count:         'Po številu ponovitev',
        end_until:         'Do datuma',
        count:             'Število ponovitev',
        until:             'Zadnji dan',
        summary:           '{count}× {pattern} ob {time}, zadnjič {last}',
        summary_none:      'V izbranem obdobju ni nobene ponovitve.',
        every_day:         'vsak dan',
        every_n_days:      'vsakih {n} dni',
        weekday_every: {
            1: 'vsak ponedeljek',
            2: 'vsak torek',
            3: 'vsako sredo',
            4: 'vsak četrtek',
            5: 'vsak petek',
            6: 'vsako soboto',
            0: 'vsako nedeljo',
        },
        every_n_weeks:     'vsakih {n} tednov ({weekday})',
        max_hint:          'Največ 52 ponovitev.',
        create:            'Ustvari serijo',
        created:           'Ustvarjenih {n} rezervacij',
        result_title:      'Serija ustvarjena',
        result_booked:     'Rezervirano: {n}',
        result_skipped:    'Teh terminov ni bilo mogoče rezervirati (zasedeno ali zaprto):',
        title:             'Ponavljajoča serija',
        loading:           'Nalagam serijo …',
        cancel_following:  'Odpovej to in vse naslednje',
        cancel_all:        'Odpovej celo serijo',
        confirm_following: 'Odpovem to in vse naslednje rezervirane ponovitve te serije?',
        confirm_all:       'Odpovem vse rezervirane ponovitve te serije? Opravljene ostanejo.',
        cancelled:         'Odpovedanih {n}',
        current:           'ta',
    },
    access: {
        title:       'Dostop',
        valid:       'Velja od {from} do {until}',
        valid_same_day: 'Velja {day} od {from} do {until}',
        download:    'Prenesi QR kodo',
        code:        'Koda',
    },
    gate: {
        subtitle:        'Čitalci kod pri vratih, prehodih in zapornicah.',
        add:             'Dodaj vrata',
        edit:            'Uredi vrata',
        none:            'Ni še nobenih vrat.',
        facility:        'Področje',
        resources:       'Viri',
        resources_help:  'Za katere vire vrata odpirajo. Prazno = vsi viri področja.',
        all_resources:   'Vsi viri',
        last_seen:       'Zadnjič',
        never_seen:      'Še nikoli',
        new_key:         'Nov ključ',
        new_key_confirm: 'Stari ključ bo takoj prenehal delovati. Čitalec je treba nastaviti z novim ključem.',
        key_title:       'Ključ čitalca',
        key_once:        'Ključ se prikaže samo enkrat. Shranite ga v nastavitve čitalca.',
        reader_title:    'Za čitalec',
        reader_get:      'Čitalec prebrano kodo pošlje na ta naslov:',
        reader_post:     'Ali pa POST na isti naslov z glavo Authorization: Bearer <ključ> in telesom:',
        reader_answer:   'Odgovor HTTP 200 pomeni odpri, 403 pomeni ne odpri.',
        key_placeholder: 'ključ',
        code_placeholder: 'prebrana koda',
    },
    report: {
        title:          'Pregledi',
        tab: {
            bills:         'Računi',
            bookings:      'Rezervacije',
            cancellations: 'Odpovedi',
            access:        'Prehodi',
        },
        total:          'Skupaj',
        issued_at:      'Izdan',
        number:         'Številka',
        booking:        'Rezervacija',
        customer:       'Stranka',
        service:        'Storitev',
        payment_type:   'Način plačila',
        amount:         'Znesek',
        eor:            'EOR',
        eor_pending:    'čaka',
        no_bills:       'V tem obdobju ni izdanih računov.',
        bookings_total: 'Rezervacij',
        completed:      'Opravljenih',
        cancelled:      'Odpovedanih',
        no_show:        'Ni prišlo',
        online_share:   'Spletnih',
        amount_booked:  'Vrednost rezervacij',
        amount_billed:  'Zaračunano',
        count:          'Število',
        by_service:     'Po storitvah',
        no_services:    'V tem obdobju ni rezervacij.',
        start_at:       'Termin',
        cancelled_at:   'Odpovedano',
        cancelled_by:   'Odpovedal',
        via:            'Kdo',
        via_staff:      'Osebje',
        via_guest:      'Gost',
        hours_before:   'Prej',
        no_cancellations: 'V tem obdobju ni odpovedi.',
        at:             'Čas',
        gate:           'Vrata',
        result:         'Rezultat',
        allowed:        'Odprto',
        denied:         'Zavrnjeno',
        reason:         'Razlog',
        no_access:      'V tem obdobju ni prehodov.',
        range_too_long: 'Obdobje je lahko dolgo največ 400 dni.',
        reasons: {
            unknown_code: 'Neznana koda',
            wrong_gate:   'Napačna vrata',
            too_early:    'Prezgodaj',
            expired:      'Poteklo',
            cancelled:    'Odpovedano',
        },
    },
    customer: {
        subtitle:             'Vsi, ki so rezervirali — za pregled in marketinške akcije.',
        search_placeholder:   'Ime, e-pošta ali telefon',
        none:                 'Ni strank.',
        name:                 'Stranka',
        card:                 'Kartica stranke',
        back:                 'Nazaj na stranke',
        bookings:             'Rezervacij',
        bookings_n:           '{n} rezervacij',
        bookings_title:       'Rezervacije stranke',
        completed:            'Opravljenih',
        cancelled:            'Odpovedanih',
        no_show:              'Ni prišla',
        upcoming:             'Prihodnjih',
        spent:                'Porabila',
        first_at:             'Prvi obisk',
        last_at:              'Zadnji obisk',
        next_at:              'Naslednji termin',
        favourite:            'Najljubša storitev',
        online_share:         'Spletnih',
        bill:                 'Račun',
        notes:                'Opombe o stranki',
        count:                'Strank',
        with_consent:         'S soglasjem za obveščanje',
        total_spent:          'Skupaj porabljeno',
        consent:              'Soglasje',
        consent_any:          'Vsi',
        consent_yes:          'Soglaša',
        consent_no:           'Brez soglasja',
        consent_label:        'Soglaša s prejemanjem obvestil in ponudb',
        consent_staff_label:  'Soglaša s prejemanjem obvestil',
        consent_none:         'Soglasja za obveščanje ni.',
        consent_given:        'Soglasje dano {at} {source}',
        consent_source: {
            online: '(spletna rezervacija)',
            staff:  '(osebje)',
        },
        any_service:          'Vse storitve',
        inactive_days:        'Neaktivni več kot (dni)',
        min_bookings:         'Najmanj rezervacij',
        sort:                 'Razvrsti',
        sort_last_at:         'Zadnji obisk',
        sort_spent:           'Porabljeno',
        sort_bookings:        'Število rezervacij',
        sort_name:            'Ime',
        export:               'Izvozi CSV (s soglasjem)',
        merge:                'Združi',
        merge_with:           'Združi z …',
        merge_title:          'Združi stranko',
        merge_help:           'Poiščite drugo kartico iste osebe. Njene rezervacije se prenesejo na {name}, kartica pa se izbriše.',
        merge_confirm:        'Rezervacije stranke {other} bodo prenesene na {target}, kartica {other} pa izbrisana.',
        merged:               'Stranki sta združeni',
        erase:                'Izbriši stranko (GDPR)',
        erase_do:             'Trajno izbriši',
        erase_confirm:        'Kartica stranke {name} bo trajno izbrisana, v njenih rezervacijah pa bodo ime, e-pošta in telefon zamenjani z »Izbrisano«. Termini, storitve in zneski ostanejo za preglede. Tega ni mogoče razveljaviti.',
        erased:               'Stranka je izbrisana',
    },
    employee: {
        subtitle:              'Zaposleni, njihove izmene in povezava z viri ter uporabniškimi računi.',
        none:                  'Ni še nobenega zaposlenega.',
        add:                   'Dodaj zaposlenega',
        edit:                  'Uredi zaposlenega',
        position:              'Delovno mesto',
        position_placeholder:  'npr. maserka, vaditelj',
        phone:                 'Telefon',
        resource:              'Rezervira se kot vir',
        resource_help:         'Le če gostje rezervirajo pri tem zaposlenem (npr. masaža pri maserki): prosti termini vira bodo sledili njegovemu urniku. Za recepcijo ipd. pustite »ni povezan«.',
        resource_help_empty:   'Ni prostega vira vrste »oseba«. Potreben je le, če gostje rezervirajo pri tem zaposlenem — dodajte ga v Nastavitve → Viri.',
        user:                  'Uporabniški račun',
        user_help:             'S prijavo vidi svoj urnik v »Moj urnik«.',
        none_linked:           '— ni povezan —',
        color:                 'Barva v urniku',
        no_color:              'Brez barve',
        notes:                 'Opombe',
        default_hours:         'Tedenska predloga',
        default_hours_help:    'Delovni čas po dnevih; malica ni na voljo za rezervacije, šteje pa v delovni čas. Iz predloge se izpolni teden z gumbom »Izpolni po predlogi«.',
    },
    schedule: {
        employee:              'Zaposleni',
        total:                 'Skupaj',
        off:                   'Prost',
        outside_count:         '{n} izven izmene',
        fill:                  'Izpolni po predlogi',
        fill_text:             'Izmene za teden {week} se izpolnijo iz tedenske predloge vsakega zaposlenega.',
        fill_keep:             'Ohrani obstoječe',
        fill_overwrite:        'Prepiši vse',
        filled:                'Ustvarjenih izmen: {n}',
        copy_previous:         'Kopiraj prejšnji teden',
        copy_confirm:          'Izmene prejšnjega tedna se prepišejo v teden {week}. Obstoječe izmene tega tedna se zamenjajo.',
        copied:                'Prepisanih izmen: {n}',
        add_absence:           'Dodaj odsotnost',
        absence_kind:          'Vrsta',
        absence_help:          'V času odsotnosti so termini povezanega vira zaprti.',
        from_date:             'Od',
        to_date:               'Do',
        range_invalid:         'Datum »do« ne sme biti pred »od«.',
        span:                  'Obdobje',
        note:                  'Opomba',
        note_placeholder:      'npr. popoldan na recepciji',
        day_off:               'Prost dan',
        save_failed:           'Izmene ni bilo mogoče shraniti',
        shift_during_absence:  'Zaposleni je ta dan odsoten ({kind}).',
        absences_week:         'Odsotnosti v tem tednu',
        delete_absence_confirm: 'Izbrišem odsotnost zaposlenega {name}?',
        outside_title:         'Rezervacije izven izmene',
        outside_subtitle:      'Rezervacije, ki po spremembi urnika niso več v izmeni zaposlenega.',
        no_employees:          'Ni aktivnih zaposlenih. Dodajte jih v Nastavitve → Zaposleni.',
        week_total:            'Ta teden: {hours}',
        not_linked:            'Vaš račun ni povezan z zaposlenim.',
        absence: {
            vacation:          'Dopust',
            sick:              'Bolniška',
            other:             'Odsotnost',
        },
    },
    demo: {
        signing_in:        'Prijavljam za predstavitev …',
        unavailable_title: 'Predstavitev tu ni na voljo',
        unavailable:       'Prijava z enim klikom deluje samo na predstavitvenem strežniku in samo za znane vloge.',
        to_login:          'Na prijavo',
    },
    about: {
        title:            'O aplikaciji',
        version:          'Različica',
        build:            'Gradnja',
        changelog:        'Spremembe',
        update_available: 'Nova različica — osveži',
        update_toast:     'Na voljo je nova različica Rezervacij. Osvežite stran.',
    },
    partner: {
        title:                 'Partnerski hoteli',
        subtitle:              'Hoteli, s katerimi sodelujete. Vsak ima svojo namestitev PMS, svoj ključ za folio, svoje ključe za povezavo in svojo pogodbo. Hotel vidi le svoje cene in svoje rezervacije.',
        none:                  'Ni še nobenega hotela.',
        add:                   'Dodaj hotel',
        edit:                  'Uredi hotel',
        name:                  'Hotel',
        name_help:             'Npr. »Hotel Bled«.',
        hotel:                 'Hotel',
        installation:          'Namestitev PMS',
        installation_help:     'Na kateri namestitvi Imprion PMS hotel dela. Seznam vodi ponudnik platforme.',
        installation_pick:     'Izberite namestitev',
        installation_required: 'Za prenos na folio izberite namestitev PMS.',
        no_installation:       'Brez namestitve PMS',
        active_help:           'Neaktiven hotel ne more rezervirati in ga osebje ne more izbrati; njegovi ključi ne delujejo.',
        folio:                 'Folio',
        folio_on:              'Na folio',
        folio_off:             'Ne',
        contract_now:          'Pogodba danes',
        contract_none:         'Brez pogodbe (cenik)',
        contracts:             'Pogodbe',
        contracts_title:       'Pogodbe — {name}',
        contracts_subtitle:    'Popust za goste hotela, provizija hotelu ali neto cena. Sprememba pogodbe velja le za nove rezervacije; narejene obdržijo svojo ceno.',
        contracts_none:        'Ni še nobene pogodbe — gostje hotela plačajo po ceniku.',
        keys:                  'Ključi',
        keys_title:            'Ključi za povezavo — {name}',
        keys_subtitle:         'S ključem PMS tega hotela bere proste termine in svoje cene ter rezervira. Ključ vidi le rezervacije tega hotela. Vpiše se v PMS, pri objektu.',
        amount_by_contract:    'Po pogodbi hotela.',
        pricing_title:         'Cena po pogodbi (različica {version})',
        pricing_no_contract:   'Cena za hotelskega gosta (brez pogodbe)',
        price_list:            'Cenik',
        price_discount:        'Popust ({pct} %)',
        price_guest:           'Cena za gosta',
        price_hotel:           'Hotelu',
        price_facility:        'Nam',
        fee_late_cancel:       'Pozna odpoved',
        fee_no_show:           'Neprihod',
    },
    contract: {
        add:                   'Nova pogodba',
        edit:                  'Uredi pogodbo',
        version:               'Različica',
        version_help:          'Shranjevanje naredi različico {next}. Rezervacije, narejene po različici {version}, obdržijo svojo ceno.',
        span:                  'Velja',
        valid_from:            'Velja od',
        valid_to:              'Velja do',
        valid_to_help:         'Prazno = do preklica.',
        valid_to_before:       'Konec je pred začetkom.',
        open_ended:            'do preklica',
        payment_terms:         'Rok plačila (dni)',
        payment_terms_help:    'Za mesečni obračun.',
        settlement:            'Obračun',
        settlement_room:       'Na sobo (hotel preprodaja)',
        settlement_room_help:  'Storitev gre na folio gosta, račun izda hotel. Hotelu mesečno izdate račun za svoj del.',
        settlement_self:       'Sami izdamo račun gostu',
        settlement_self_help:  'Gost plača pri vas, hotel dobi provizijo.',
        lines:                 'Pogoji',
        lines_help:            'Po področju in po želji za posamezno storitev — pogoj za storitev ima prednost. Področje brez pogoja gre po ceniku.',
        lines_none:            'Ni pogojev — vse po ceniku.',
        line_add:              'Dodaj pogoj',
        facility:              'Področje',
        service:               'Storitev',
        all_services:          'Vse storitve področja',
        discount:              'Popust (%)',
        commission:            'Provizija (%)',
        net_price:             'Neto cena',
        net_price_none:        'brez',
        notes:                 'Opombe',
        state_now:             'Velja',
        state_future:          'Prihodnja',
        state_past:            'Pretekla',
        example_room:          'Npr. {service}: cenik {list}, gost plača {guest}, hotel obdrži {commission}, vam {net}.',
        example_net:           'Npr. {service}: cenik {list}, gost plača {guest}, vam {net}, hotel obdrži {hotel}.',
        example_self:          'Npr. {service}: cenik {list}, gost plača {guest} pri vas, hotelu provizija {commission}.',
        history:               'Zgodovina',
        history_title:         'Zgodovina pogodbe',
        history_subtitle:      'Vsaka shranitev je nova različica. Rezervacije obdržijo ceno različice, po kateri so bile narejene.',
        history_first:         'Prva različica.',
        history_same:          'Shranjeno brez spremembe pogojev.',
        version_n:             'Različica {n}',
        version_current:       'velja zdaj',
        payment_terms_n:       'rok plačila {n} dni',
        term_discount:         'popust {pct}',
        term_commission:       'provizija {pct}',
        term_net:              'neto cena {amount}',
        changed_span:          'Veljavnost: {from} → {to}',
        changed_settlement:    'Obračun: {from} → {to}',
        changed_terms:         'Rok plačila: {from} → {to} dni',
        changed_notes:         'Spremenjene opombe',
        changed_line:          '{subject}: {from} → {to}',
        changed_line_added:    'Dodan pogoj — {line}',
        changed_line_removed:  'Odstranjen pogoj — {line}',
    },
    installation: {
        subtitle:              'Namestitve Imprion PMS, na katerih lahko delajo partnerski hoteli. Stranke izbirajo s tega seznama in naslova ne vpisujejo.',
        none:                  'Ni še nobene namestitve.',
        add:                   'Dodaj namestitev',
        edit:                  'Uredi namestitev',
        name_help:             'Kako jo vidijo stranke, npr. »Imprion PMS«.',
        base_url:              'Naslov API',
        base_url_help:         'Do /api/pms/v1, na primer https://recepcija.pms.imprion.dev/api/pms/v1.',
        base_url_invalid:      'Naslov se mora začeti s https://.',
        active_help:           'Neaktivne namestitve stranke ne vidijo in povezave nanjo ne delujejo.',
    },
    pms: {
        link_title:            'Na folio gosta',
        link_subtitle:         'Opravljena storitev hotelskega gosta gre kot postavka na njegov folio v Imprion PMS. Račun gostu izda hotel ob odjavi; Rezervacije za to rezervacijo ne izdajo računa.',
        not_configured_title:  'PMS ni nastavljen',
        not_configured:        'Platforma še nima nobene namestitve Imprion PMS. Obrnite se na ponudnika.',
        enabled:               'Prenašaj na folio gosta v Imprion PMS',
        enabled_help:          'Osebje pri rezervaciji izbere gosta tega hotela; ob zaključku gre storitev na njegov folio.',
        key:                   'Ključ za folio (izda ga hotel)',
        key_help:              'Ključ izda hotel v PMS (objekt → Fiskalizacija → »Blagajne in povezave« → Izdaj ključ); PMS mora imeti modul »Gostinstvo (POS)«. To je le pot do folia — računa ne izda nobena blagajna.',
        key_saved:             'Ključ je shranjen — pustite prazno za nespremenjeno',
        cash_register_name:    'Oznaka na foliu',
        cash_register_help:    'Izpiše se ob vsaki postavki na foliu gosta, npr. »Rezervacije« ali »Wellness«.',
        test:                  'Preveri povezavo',
        test_ok:               'Povezava deluje — {n} zasedenih sob',

        keys_title:            'Ključi za integracijo',
        keys_subtitle:         'Z njimi PMS ali drug sistem bere proste termine ter ustvarja in odpoveduje rezervacije.',
        keys_none:             'Ni še nobenega ključa.',
        key_create:            'Nov ključ',
        key_name_help:         'Npr. »Imprion PMS — Hotel Bled«.',
        key_created_title:     'Nov ključ za integracijo',
        key_prefix:            'Ključ',
        key_last_used:         'Zadnja uporaba',
        key_never_used:        'Še ni bil uporabljen',
        key_revoke:            'Prekliči',
        key_revoke_confirm:    'Prekličem ključ »{name}«? Sistem, ki ga uporablja, ne bo več imel dostopa.',
        key_placeholder:       'ključ',
        developers:            'Za razvijalce',
        developers_help:       'Osnovni naslov in glava za vse klice:',

        hotel_guest:           'Hotelski gost',
        hotel_guest_help:      'Ob zaključku gre storitev na njegov folio v PMS.',
        hotel_guest_none:      'Ni hotelski gost',
        hotel_guest_search:    'Soba ali priimek …',
        hotel_guest_clear:     'Odstrani hotelskega gosta',
        until:                 'do {date}',
        room_guest:            'Soba {room} · {guest}',
        room:                  'Soba',
        pick_room:             'Izberite sobo',
        settle_hint:           'Hotelski gost: soba {room} · {guest}.',
        folio_off:             'Prenos na folio pri hotelu »{hotel}« ni vklopljen, zato storitve ni mogoče prenesti na folio gosta. Vklopi ga skrbnik v Nastavitve → Hoteli in PMS → hotel.',
        complete_to_room:      'Zaključi in prenesi na folio',
        charge_room:           'Prenesi na folio',
        charge_confirm:        'Prenesi',
        charge_title:          'Na foliu gosta',
        charge_bill:           'Številka',
        charge_posted:         'Knjiženo',
        charge_voided:         'storniran',
    },
}
